import { NavigateFunction } from 'react-router-dom';
import { msalInstance } from '../msalInstance';
import { showToast } from '../notifications';

export const SESSION_STORAGE_KEYS = ['user_email', 'user_nome', 'user_departamento'] as const;

export const LOGIN_REDIRECT_MESSAGE_KEY = 'login_redirect_message';

export function clearLocalSession(): void {
  SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function isAuthFailure(status?: number, message?: string | null): boolean {
  if (status === 401) return true;

  const text = (message || '').toLowerCase();
  return (
    text.includes('expirou') ||
    text.includes('expirada') ||
    text.includes('faça login') ||
    text.includes('faca login') ||
    text.includes('token inválido') ||
    text.includes('token invalido') ||
    text.includes('nenhuma conta encontrada') ||
    text.includes('não foi possível obter token') ||
    text.includes('nao foi possivel obter token')
  );
}

export const DEFAULT_SESSION_EXPIRED_MESSAGE =
  'Sua sessão expirou. Faça login novamente para continuar.';

export async function redirectToLogin(navigate: NavigateFunction, message?: string): Promise<void> {
  void navigate;
  const account = msalInstance.getActiveAccount();
  const alertMessage = message || DEFAULT_SESSION_EXPIRED_MESSAGE;
  showToast({
    type: 'warning',
    title: 'Sessão encerrada',
    message: alertMessage,
    duration: 7000,
  });
  clearLocalSession();
  sessionStorage.clear();
  await msalInstance.logoutRedirect({
    account: account ?? undefined,
    postLogoutRedirectUri: `${window.location.origin}/Login`,
  });
}

export function consumeLoginRedirectMessage(): string | null {
  const message = sessionStorage.getItem(LOGIN_REDIRECT_MESSAGE_KEY);
  if (message) {
    sessionStorage.removeItem(LOGIN_REDIRECT_MESSAGE_KEY);
  }
  return message;
}
